import clsx from 'clsx'

const MetricCard = ({ 
  title, 
  value, 
  delta, 
  deltaType = 'neutral', 
  icon: Icon,
  className = '',
  trend = null 
}) => {
  const deltaColors = {
    positive: 'text-green-600',
    negative: 'text-red-600',
    neutral: 'text-gray-600'
  }

  return (
    <div className={clsx('metric-card', className)}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <div className="flex items-baseline space-x-2 mt-1">
            <p className="text-2xl font-bold text-gray-900">{value}</p>
            {delta && (
              <span className={clsx('text-sm font-medium', deltaColors[deltaType])}>
                {deltaType === 'positive' && '+'}
                {delta}
              </span>
            )}
          </div>
          {trend && (
            <p className="text-xs text-gray-500 mt-1">
              {typeof trend === 'string' ? trend : 
               typeof trend === 'object' && trend.value !== undefined ? 
                 `${trend.isPositive ? '+' : ''}${trend.value}` : 
                 String(trend)
              }
            </p>
          )}
        </div>
        {Icon && (
          <div className="flex-shrink-0">
            <Icon className="h-8 w-8 text-gray-400" />
          </div>
        )}
      </div>
    </div>
  )
}

export default MetricCard
